var React = require('react');

function LogoBackground (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#background)","key":0},[React.createElement("path",{"d":"M189.599 288.064L17.0783 -11.0304L362.362 -10.8907L189.599 288.064Z","stroke":"white","key":0}),React.createElement("path",{"d":"M102.118 263.256L83.7549 -79.8049L390.035 75.8227L102.118 263.256Z","stroke":"white","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M43.3958 -47.9847L382.658 24.9606L149.854 282.298L43.3958 -47.9847Z","fill":"white","fillOpacity":"0.8","key":2})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"background"},React.createElement("rect",{"width":"400","height":"294.455","fill":"white"})))]);
}

LogoBackground.defaultProps = {"width":"400","height":"295","viewBox":"0 0 400 295","fill":"none"};

module.exports = LogoBackground;

LogoBackground.default = LogoBackground;
